module.exports = __webpack_public_path__ + "img/dori_chashkada.5bc8580f.jpg";